document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-carousel]').forEach(carousel => {
    const viewport = carousel.querySelector('.seo-carousel__viewport');
    const slides = carousel.querySelectorAll('.seo-carousel__slide');
    const prev = carousel.querySelector('.seo-carousel__arrow.prev');
    const next = carousel.querySelector('.seo-carousel__arrow.next');
    const thumbs = carousel.querySelectorAll('.seo-carousel__thumb');

    if (!viewport || slides.length === 0) return;

    let index = 0;

    function slideWidth() {
      return viewport.getBoundingClientRect().width;
    }

    function update() {
      const width = slideWidth();
      viewport.scrollTo({
        left: index * width,
        behavior: 'smooth'
      });

      thumbs.forEach((t, i) => {
        t.classList.toggle('active', i === index);
      });
    }

    next?.addEventListener('click', () => {
      index = Math.min(index + 1, slides.length - 1);
      update();
    });

    prev?.addEventListener('click', () => {
      index = Math.max(index - 1, 0);
      update();
    });

    thumbs.forEach((thumb, i) => {
      thumb.addEventListener('click', () => {
        index = i;
        update();
      });
    });

    window.addEventListener('resize', update);
  });
});